import React from "react";

type IconProps = {
    className?: string;
};

export function InstagramIcon({ className }: IconProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.3333 4.32358H10.6667C6.98477 4.32358 4 7.30835 4 10.9902V21.6569C4 25.3388 6.98477 28.3236 10.6667 28.3236H21.3333C25.0152 28.3236 28 25.3388 28 21.6569V10.9902C28 7.30835 25.0152 4.32358 21.3333 4.32358ZM25.6667 21.6569C25.6593 24.047 23.7235 25.9829 21.3333 25.9902H10.6667C8.27647 25.9829 6.34065 24.047 6.33333 21.6569V10.9902C6.34065 8.60004 8.27647 6.66423 10.6667 6.65691H21.3333C23.7235 6.66423 25.6593 8.60004 25.6667 10.9902V21.6569ZM22.3333 11.3236C23.0697 11.3236 23.6667 10.7266 23.6667 9.99024C23.6667 9.25387 23.0697 8.65691 22.3333 8.65691C21.5969 8.65691 21 9.25387 21 9.99024C21 10.7266 21.5969 11.3236 22.3333 11.3236ZM16 10.3236C12.6863 10.3236 10 13.0099 10 16.3236C10 19.6373 12.6863 22.3236 16 22.3236C19.3137 22.3236 22 19.6373 22 16.3236C22.0036 14.7312 21.3725 13.203 20.2465 12.077C19.1205 10.951 17.5924 10.32 16 10.3236ZM12.3333 16.3236C12.3333 18.3486 13.9749 19.9902 16 19.9902C18.0251 19.9902 19.6667 18.3486 19.6667 16.3236C19.6667 14.2985 18.0251 12.6569 16 12.6569C13.9749 12.6569 12.3333 14.2985 12.3333 16.3236Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function YouTubeIcon({ className }: IconProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.456 8.256C28.512 8.512 29.344 9.344 29.6 10.4C30.112 12.256 30.112 16 30.112 16C30.112 16 30.112 19.744 29.6 21.6C29.344 22.656 28.512 23.488 27.456 23.744C25.6 24.256 16 24.256 16 24.256C16 24.256 6.4 24.256 4.544 23.744C3.488 23.488 2.656 22.656 2.4 21.6C1.888 19.744 1.888 16 1.888 16C1.888 16 1.888 12.256 2.4 10.4C2.656 9.344 3.488 8.512 4.544 8.256C6.4 7.744 16 7.744 16 7.744C16 7.744 25.6 7.744 27.456 8.256ZM13.248 19.52L21.376 16L13.248 12.48V19.52Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function FacebookIcon({ className }: IconProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M29.3327 16.405C29.3327 8.99625 23.3632 2.99023 15.9993 2.99023C8.63555 2.99023 2.66602 8.99625 2.66602 16.405C2.66602 23.1006 7.5418 28.6505 13.916 29.6569V20.2828H10.5306V16.405H13.916V13.4496C13.916 10.0875 15.9067 8.23039 18.9521 8.23039C20.4111 8.23039 21.9368 8.49241 21.9368 8.49241V11.7937H20.2556C18.5993 11.7937 18.0827 12.8279 18.0827 13.8888V16.405H21.7805L21.1895 20.2828H18.0827V29.6569C24.4569 28.6505 29.3327 23.1009 29.3327 16.405Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function LinkedInIcon({ className }: IconProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M6 4.82358H26C26.8284 4.82358 27.5 5.49515 27.5 6.32358V26.3236C27.5 27.152 26.8284 27.8236 26 27.8236H6C5.17158 27.8236 4.5 27.152 4.5 26.3236V6.32358C4.5 5.49515 5.17157 4.82358 6 4.82358ZM7.0752 25.2562H11.6104V12.847H7.0752V25.2562ZM20.3975 12.5404C20.0376 12.5209 19.5936 12.4939 19.1641 12.5804C18.3188 12.7498 17.5351 13.0893 16.873 13.6488V12.8392H12.5107V25.2523H17.0625V24.4857C17.0625 23.9792 17.0619 23.4726 17.0615 22.9662L17.0664 18.9124C17.0682 18.5903 17.084 18.3046 17.1504 18.058C17.4081 17.1063 18.2383 16.5396 19.1318 16.681H19.1328C19.4314 16.7278 19.6536 16.8337 19.8174 16.9759C19.9399 17.0823 20.0443 17.2212 20.123 17.4007L20.1924 17.5951C20.2778 17.8887 20.3299 18.2043 20.3525 18.5238L20.3652 18.8451C20.3804 20.2379 20.3781 21.6315 20.376 23.0287C20.3752 23.5216 20.375 24.0157 20.375 24.5091V25.2503H24.9375V24.4769C24.9375 23.8743 24.9369 23.2717 24.9365 22.6693C24.9359 21.1631 24.9355 19.6573 24.9395 18.1517C24.9414 17.4343 24.8639 16.7211 24.6855 16.0179V16.0169C24.4099 14.9349 23.8306 14.0176 22.8838 13.3568H22.8848C22.2312 12.8991 21.488 12.5879 20.6426 12.5531C20.5631 12.5498 20.4821 12.5449 20.3975 12.5404ZM9.35449 7.15659C7.91044 7.12401 6.79723 8.26136 6.79004 9.65952V9.66049C6.7833 11.1421 7.94428 12.2081 9.2793 12.2152C10.5717 12.2215 11.718 11.3606 11.8486 9.9476L11.8613 9.65756C11.8675 8.256 10.7848 7.18858 9.35449 7.15659Z"
                fill="currentColor"
                stroke="currentColor"
            />
        </svg>
    );
}
